import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)
const router = new VueRouter({
  routes,
  mode: 'history',
})

import { domain, clientId, audience } from "./auth/auth_config.json";
import { Auth0Plugin, getInstance as getAuth0Instance } from "./auth";
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    getAuth0Instance().getTokenSilently().then(t => window.localStorage.setItem('vue.auth.token', t))
    router.push(
        appState && appState.targetUrl
            ? appState.targetUrl
            : window.location.pathname
    );
  }
});


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
